import classNames from 'classnames';
import Icon from '@/components/atoms/icon/icon';
import Typography from '@/components/atoms/typography/typography';
import { useWindowSize } from '@/libraries/hooks/use-window-size';
import styles from './travel-plan-table.module.scss';

export interface TravelPlanTableProps {
  className?: string;
  columnsHeadlines?: string[] | null;
  icon?: IconName;
  rows?: { cells: string[] }[];
  showColumnHeadlines?: boolean;
  tableHeadline?: string;
}

const TravelPlanTable = ({
  className,
  columnsHeadlines = [],
  icon,
  rows = [],
  showColumnHeadlines = false,
  tableHeadline,
}: TravelPlanTableProps) => {
  const isTablet = useWindowSize('tablet');
  const hasHeadlines = columnsHeadlines && showColumnHeadlines;

  return (
    <div
      className={classNames(styles.component, className, {
        [styles.hasHeadlines]: hasHeadlines,
      })}
    >
      {tableHeadline && (
        <div className={classNames(styles.tableRow, styles.isHead)}>
          {icon && <Icon className={styles.tableIcon} name={icon} size={20} />}

          <Typography className={styles.tableHeadline} tagStyle="headingSmall">
            {tableHeadline}
          </Typography>
        </div>
      )}

      {isTablet && hasHeadlines && (
        <div className={styles.tableRow}>
          {columnsHeadlines.map((headline, headlineIndex) => (
            <Typography key={headlineIndex} tagStyle="bodyMedium">
              {headline}
            </Typography>
          ))}
        </div>
      )}

      {rows.map((row, rowIndex) => (
        <div key={rowIndex} className={styles.tableRow}>
          {row.cells.map((cell, cellIndex) => (
            <div key={cellIndex} className={styles.tableRowItem}>
              {(!isTablet || !showColumnHeadlines) &&
                columnsHeadlines?.[cellIndex] && (
                  <Typography tagStyle="bodyMedium">
                    {columnsHeadlines[cellIndex]}
                  </Typography>
                )}

              {!hasHeadlines && cellIndex === 0 ? (
                <Typography
                  className={classNames({
                    [styles.tableItemValue]: hasHeadlines,
                  })}
                  tagStyle={hasHeadlines ? 'bodyMediumBold' : 'bodyMedium'}
                >
                  {cell}
                </Typography>
              ) : (
                <Typography
                  className={styles.tableItemValue}
                  tagStyle="bodyMediumBold"
                >
                  {cell}
                </Typography>
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

TravelPlanTable.displayName = 'TravelPlanTable';

export default TravelPlanTable;
